import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import * as BoardMemberAPI from '../../../API/BoardMemberAPI'
import { immer } from 'zustand/middleware/immer'

const initialState = {
    // create board member
    createBoardMemberData: null,
    createBoardMemberDataLoading: false,
    userProfileModalOpen: false,
    nodeModalData: {},
    // get all board member
    getAllBoardMemberDetails: [],
    getAllBoardMemberDetailsLoading: false
}

const BoardMemberStore = create(devtools(immer((set, get) => ({
    ...initialState,
    setNodeModalData: async (data) => {
        set({ nodeModalData: data })
    },
    clearNodeModalData: async () => {
        set({ nodeModalData: {} })
    },
    userProfileModalShow: async () => {
        set({ userProfileModalOpen: true })
    },
    userProfileModalHide: () => {
        set({ userProfileModalOpen: false })
    },
    getAllBoardMember: async (orgId) => {
        set({ getAllBoardMemberDetailsLoading: true })
        const response = await BoardMemberAPI.getAllBoardMember(orgId)
        if (response.data) {
            set({ getAllBoardMemberDetailsLoading: false, getAllBoardMemberDetails: response?.data })
            return response
        } else {
            set({ getAllBoardMemberDetailsLoading: false })
        }
    },

    createBoardMember: async (loginId, data) => {
        set({ createBoardMemberDataLoading: true })
        const response = await BoardMemberAPI.createBoardMember(loginId, data)
        if (response.data) {
            set({ createBoardMemberDataLoading: false, createBoardMemberData: response?.data })
            return response
        } else {
            set({ createBoardMemberDataLoading: false })
            return response
        }
    }

}))))

export const useBoardMemberStore = BoardMemberStore
